import { SectionLabel } from './section-label';

type FeatureItem = {
  icon?: string;
  title: string;
  description: string;
};

type Props = {
  label?: string;
  heading?: string;
  columns?: 2 | 3;
  items: FeatureItem[];
};

export function FeatureGrid({ label, heading, columns = 2, items }: Props) {
  const gridClass =
    columns === 3
      ? 'grid grid-cols-1 md:grid-cols-3 gap-6'
      : 'grid grid-cols-1 md:grid-cols-2 gap-6';

  return (
    <div class="max-w-4xl mx-auto px-6 py-8">
      {label && <SectionLabel>{label}</SectionLabel>}
      {heading && (
        <h2
          class="text-2xl font-extrabold mb-8"
          style="letter-spacing: -0.02em; padding-bottom: 0.1em; background: linear-gradient(135deg, var(--m-blue-deep) 0%, var(--m-blue-light) 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;"
        >
          {heading}
        </h2>
      )}
      <div class={gridClass}>
        {items.map((item, i) => (
          <div key={i} class="bg-white rounded-xl p-6 border border-gray-100 shadow-sm">
            {item.icon && (
              <div class="w-10 h-10 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center text-lg mb-3">
                {item.icon}
              </div>
            )}
            <h3 class="font-bold text-gray-900 mb-2">{item.title}</h3>
            <p class="text-gray-600 text-sm leading-relaxed">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
